import React from 'react';

import './index.sp.scss';
import SpBasicTemplate from 'components/templates/SpBasicTemplate';
import SpInputItem from 'components/molecules/SpInputItem';
import SpStepProgressBar from 'components/molecules/SpStepProgressBar';
import SpPointComment from 'components/molecules/SpPointComment';

import { POINT_COMMENT_MAP } from 'utils/constant';

const PresentSP = ({
  // state
  basicInfoList,
  // onClick
  onClickMainButton,
  // 入力チェック
  valid,
  showLoading,
}) => (
  <div className="AddInfo SP">
    <SpBasicTemplate 
      path={window.location.pathname}
      onClickMainButton={onClickMainButton}
      valid={valid}
      showLoading={showLoading}
    >
      <SpStepProgressBar currentStep='7' />
      <div id="addInfo" className="contents">
        <div className="titleArea">
          <p className="title">基本情報</p>
        </div>
        <SpPointComment labelList={POINT_COMMENT_MAP.basicInfomationCmnt.labelList} pattern={POINT_COMMENT_MAP.basicInfomationCmnt.pattern} />
        <div id='basicInfo' className='basicInfo'>
          {basicInfoList.map((data) => {
            return (
              <span key={data.title}>
                <SpInputItem
                  title={data.title}
                  subTitle={data.subTitle}
                  label={data.label}
                  questionMark={data.questionMark}
                  popUpTitle={data.popUpTitle}
                  popUpDetail={data.popUpDetail}
                >
                  {data.input}
                </SpInputItem>
              </span>
            );
          })}
        </div>
      </div>
    </SpBasicTemplate>
  </div>
);

export default PresentSP;